// Module
var code = `<div class="option-analyzer-panel" {{^.visible}}style="display: none;" {{/}}>
    <div class="option-analyzer-panel-chart-container">
        <optionAnalyzerChartRactive name="chart" terceraChartPanelContext="{{terceraChartPanelContext}}" />
    </div>
    <div class="option-analyzer-panel-settings-container {{isSettingsExpanded ? '_expanded' : '_collapsed'}}">
        <div class="option-analyzer-panel-settings-expand-collapse" on-click="expandCollapsSettings_btnClick">
            {{#if isSettingsExpanded}}
                <div class="option-analyzer-panel-settings-expand-collapse-title">
                    <svg>
                        <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#settings"></use>
                    </svg>
                    <terceraLabel name="settingsLabel" text="{{settingsLabel}}"/>
                </div> 
            {{/if}}
            <svg>
                <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#ArrowRight"></use>
            </svg>
        </div>
        <div class="option-analyzer-panel-settings">
            <div class="option-analyzer-panel-settings-element">
                <div class="option-analyzer-panel-settings-element-title">
                    <terceraLabel name="chartTypeLabel" text="{{chartTypeLabel}}"/>
                </div>
                <div class="option-analyzer-panel-settings-element-control">
                    <terceraComboBox name="chartTypeCombobox" items="{{chartTypeItems}}" selectedItem="{{selectedChartTypeItem}}" />
                </div>
            </div>
            <div class="option-analyzer-panel-settings-element">
                <div class="option-analyzer-panel-settings-element-title">
                    <terceraLabel name="linesLabel" text="{{linesLabel}}"/>
                </div>
                <div class="option-analyzer-panel-settings-element-control">
                    <terceraComboBox name="linesCombobox" items="{{linesTypeItems}}" selectedItem="{{selectedLinesTypeItem}}" />
                </div>
            </div>
            <div class="option-analyzer-panel-settings-element">
                <div class="option-analyzer-panel-settings-element-title">
                    <terceraLabel name="volatilityNumericLabel" text="{{volatilityNumericLabel}}"/>
                </div>
                <div class="option-analyzer-panel-settings-element-control">
                    <terceraNumeric name="volatilityChangeNumeric" value="{{volatilityChange}}" minValue="{{volatilityChangeMinValue}}" maxValue="{{volatilityChangeMaxValue}}" step="{{volatilityChangeStep}}" decimalPrecision="{{volatilityChangeDecimalPlaces}}" />
                </div>
            </div>
            <div class="option-analyzer-panel-settings-element">
                <div class="option-analyzer-panel-settings-element-title">
                    <terceraLabel name="volatilityTableLabel" text="{{volatilityTableLabel}}"/>
                </div>
                <div class="option-analyzer-panel-settings-element-control _table">
                    <quickTableRactive name="volatityTable"/>
                </div>
            </div>
<!--             <div class="option-analyzer-panel-settings-element">
                <div class="option-analyzer-panel-settings-element-title _separator">
                    <terceraLabel name="probabilityCalculationLabel" text="{{probabilityCalculationLabel}}"/>
                </div>
            </div>
            <div class="option-analyzer-panel-settings-element">
                <div class="option-analyzer-panel-settings-element-title">
                    <terceraLabel name="daysLabel" text="{{daysLabel}}"/>
                </div>
                <div class="option-analyzer-panel-settings-element-control">
                    <terceraNumeric name="daysNumeric" value="{{probabilityCalculationDays}}" minValue="{{probabilityCalculationDaysMinValue}}" maxValue="{{probabilityCalculationDaysMaxValue}}" step="{{probabilityCalculationDaysStep}}" decimalPrecision="0" />
                </div>           
            </div>
            <div class="option-analyzer-panel-settings-element">
                <div class="option-analyzer-panel-settings-element-title">
                    <terceraLabel name="modeLabel" text="{{modeLabel}}"/>
                </div>
                <div class="option-analyzer-panel-settings-element-control _probability">
                    <terceraComboBox name="modeCombobox" items="{{probabilityCalculationModeItems}}" selectedItem="{{selectedProbabilityCalculationModeItem}}" />
                    <terceraButton name="refreshButton" SVG="true" terceraButtonStyle="js-button-refresh" on-btnClick="refreshProbability_btnClick" />
                </div>
            </div> -->
            <div class="option-analyzer-panel-settings-element">
                <terceraButton name="optionCalculator" text="{{.buttonCalculatorText}}" terceraButtonStyle="js-button-gray25 option-calculator-button" on-componentClick="calculator_btnClick" SVG="true" />
            </div>
        </div>
    </div>
</div>`;
// Exports
export default code;